import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import NavigationActionFooter from 'components/common/general/NavigationActionFooter';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import { MedicalCategoryName } from 'components/common/subscriber/imq/medical-category/MedicalCategoryName';
import { MedicalCategoryProgress } from 'components/common/subscriber/imq/medical-category/MedicalCategoryProgress';
import { useImqBrokerMedicalCategoryPageStore } from 'store/pages/quote/imq-add-employees/medical-category/pageStore';
import { DynamicForm } from '@insurancemenu/imenu-components-lib';

export const PageContent: React.FC = observer(() => {
  const {
    getInitialData,
    isInitialLoading,
    isFormValid,
    isActionLoading,
    flowDelegate,
    domainParams,
    categoryName,
    subscriberImqModule,
    dynamicFormDelegate,
    nextCategoryName,
    returnBack,
    saveAndReturnToList,
    saveAndGoToNextForm,
  } = useImqBrokerMedicalCategoryPageStore();

  useEffect(() => {
    void getInitialData();
  }, [categoryName, getInitialData]);

  return (
    <PageInFlowNoSidebarLayout
      contentWidth="standard"
      domainParams={{ ...domainParams }}
      pageId={QuoteRouteV2Id.IMQ_ADD_EMPLOYEES_HEALTH_QUESTIONNAIRE_MEDICAL_CATEGORY}
      isInitialLoading={isInitialLoading}
      isInfoSectionLoading={flowDelegate.isFlowDataLoading}
      moreInfoBlob={
        flowDelegate.groupInfoDelegate.moreInfoBlobInput
          ? buildGroupContextMoreInfoBlobProps(flowDelegate.groupInfoDelegate.moreInfoBlobInput)
          : undefined
      }
      pageHeader={{
        subtitle: <MedicalCategoryName categoryName={categoryName} />,
        spacing: {
          top: 'm',
          bottom: 's',
        },
      }}
      pageFooter={null}
    >
      <>
        <MedicalCategoryProgress progressText={subscriberImqModule.categoriesProgressText} />
        <DynamicForm formDelegate={dynamicFormDelegate} showFooter={false} />;
        <NavigationActionFooter
          allowSubmit={!isActionLoading && isFormValid}
          isLoading={isActionLoading}
          back={{
            text: 'Back To List',
            handler: returnBack,
          }}
          saveAndReturn={{
            text: 'Save & Return to List',
            handler: saveAndReturnToList,
          }}
          saveAndContinue={
            nextCategoryName
              ? {
                  text: 'Save & Go to Next Form',
                  handler: saveAndGoToNextForm,
                }
              : undefined
          }
        />
      </>
    </PageInFlowNoSidebarLayout>
  );
});
